import React from 'react';

export default class Pricing extends React.Component{
    constructor(){
        super();
        this.state = {
            current: []
        }
    }

    full_list = [
     'Cabin Filter - $64.99',
     'Air Filter - $39.99',
     'Throttle Body Service - $54.95',
     'Coolant Service - $79.99',
     'State Inspection and Emissions (Pass or Fail) - $92',
     'Regular Oil Change 5 Qrts - $70',
     'Synthetic Oil Change 5 Qrts - $90',
     'Brakes and Rotors (Average Car) - $380 per Axle',
     'Brakes and Rotors (Small SUV) - $399 per Axle',
     'Brakes and Rotors (Trucks) - Call For Pricing',
     'Tire Rotation (Car) - $24.99',
     'Tire Rotation (Truck) - $29.99',
     'Balance Car Tires (2) - $59.99',
     'Balance Truck Tires (2) - $69.99',
     'Turn Signal Bulb - $25',
     'Headlight Bulb - $70',
     'Electrical Diagnosis - $85',
     'A/C Charge (R134) - $249.99',
     'A/C Charge (R1234YF Freon) - $399',
     'A/C System Check - $49.99'
    ];
    
    getList = (prices) =>{
        prices = prices.sort();
        let list = prices.map((item)=>{
            return <li class="price_item" style={styles.li}><p style={styles.p}>{item}</p></li>;
        })
        this.setState({current: list});
    }

    search = (e) =>{
        let input = e.target.value;
        let result = this.full_list.filter((item) =>{
            let check = item.toUpperCase();
            if(check.includes(input.toUpperCase())){
                return item;
            }
        })
        this.getList(result);
    }

    componentDidMount(){
        this.getList(this.full_list);
    }

    render(){

        return(
            <div style={styles.wrapper}>
                <input style={styles.input} onChange={this.search.bind(this)} placeholder="Search.." />
                <ul style={styles.ul}>{this.state.current}</ul>
            </div>
        )
    }
}

const styles = {
    wrapper: {width: '100%', height: '700px', paddingTop: '40px'},
    input: {left: '10vw', position: 'absolute', fontSize: '2vh', width: '250px', height: '30px', borderRadius: "25px", paddingLeft: '20px', outline: 'none'},
    ul: {listStyleType: 'none', width: '70%', height: '650px', overflow: 'auto', margin: 'auto', color: 'white'},
    li: {fontSize: '3vh', width: '100%', height: '90px', borderBottom: '1px groove black'},
    p: {marginTop: '50px'}
}

// the blue color: '#3838ff'